import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
    return (
        <div className="min-h-screen">
            {/* Hero Section */}
            <section className="relative h-screen flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <img
                        src="https://picsum.photos/1920/1080?random=1"
                        alt="Hero background"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black opacity-50"></div>
                </div>
                <div className="relative z-10 text-center text-white">
                    <h1 className="text-5xl md:text-7xl font-bold mb-4 animate-fade-in-up">
                        Welcome to <span className="text-bilih-blue">Bilih</span>
                    </h1>
                    <p className="text-xl md:text-2xl mb-8 animate-fade-in-up delay-200">
                        Innovating the Way We Live
                    </p>
                    <Link
                        to="/contact"
                        className="bg-bilih-blue text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-bilih-green transition-colors duration-300 animate-fade-in-up delay-400"
                    >
                        Get Started
                    </Link>
                </div>
                <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent"></div>
            </section>

            {/* Featured Services */}
            <section className="py-20 bg-gray-100">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">Our Services</h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <ServiceCard
                            title="Web Development"
                            description="Crafting responsive and user-friendly websites tailored to your needs."
                            icon="🌐"
                        />
                        <ServiceCard
                            title="Mobile Apps"
                            description="Developing innovative mobile applications for iOS and Android platforms."
                            icon="📱"
                        />
                        <ServiceCard
                            title="Automation Services"
                            description="Streamlining your business processes with cutting-edge automation solutions."
                            icon="⚙️"
                        />
                    </div>
                    <div className="text-center mt-12">
                        <Link to="/services" className="bg-bilih-blue text-white px-6 py-2 rounded-full hover:bg-bilih-green transition-colors duration-300">
                            View All Services
                        </Link>
                    </div>
                </div>
            </section>

            {/* Call to Action */}
            <section className="py-20 bg-bilih-blue text-white">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-3xl font-bold mb-4">Ready to Innovate?</h2>
                    <p className="text-xl mb-8">Let's work together to bring your ideas to life.</p>
                    <Link to="/contact" className="bg-white text-bilih-blue px-8 py-3 rounded-full text-lg font-semibold hover:bg-bilih-yellow hover:text-white transition-colors duration-300">
                        Get in Touch
                    </Link>
                </div>
            </section>
        </div>
    );
}

function ServiceCard({ title, description, icon }) {
    return (
        <div className="bg-white rounded-lg shadow-md p-6 transition-transform duration-300 hover:transform hover:scale-105">
            <div className="text-4xl mb-4">{icon}</div>
            <h3 className="text-xl font-semibold mb-2">{title}</h3>
            <p className="text-gray-600">{description}</p>
        </div>
    );
}

export default Home;